import { useState, useContext } from 'react';

import './login-page.css';

import { authenticateApiTokenWithAccessKey } from '../../api-token';
import { LoginContext, loginAction } from './login-gate';

import { 
    PageFooter, 
    PageHeader, 
    PageLayout, 
    PageSection, 
    Header, 
    InputBox, 
    Button,
    Icon,
} from '../../components/components';

export function LoginPage() {
    const loginContext = useContext(LoginContext);

    const [accessKey, setAccessKey] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const login = async () => {
        setLoading(true);
        setError("");

        if (!accessKey) {
            setLoading(false);
            setError("No access key entered");
            return;
        }

        const [loggedIn, token, expiresAt, error] = await authenticateApiTokenWithAccessKey(accessKey);
        if (!loggedIn) {
            setLoading(false);
            setError(error);
            return;
        }

        loginContext.dispatch(loginAction(token, expiresAt));
    };

    return (
        <PageLayout 
            header={<PageHeader name="Puzzel wallboards" />}
            footer={<PageFooter />}>
            <PageSection centered="true" class="welcome-section">
                <Header>
                    Welcome to the Puzzel wallboards
                </Header>
                <p className="welcome-description">
                    Monitor your puzzel queues in real-time.
                </p>
            </PageSection>
            <PageSection class="login-page">
                <div className="login-password">
                    <InputBox
                        placeholder="Enter your access key"
                        type="password"
                        value={accessKey}
                        error={error}
                        readonly={loading}
                        valueChanged={accessKey => setAccessKey(accessKey)}
                        submitted={() => login()}>
                    </InputBox>
                    <Button
                        icon="ic_lock_open"
                        loading={loading}
                        clicked={() => login()}>
                        Login
                    </Button>
                </div>
                <Icon name="manypixels_login_wallboard" class="login-illustration" />
            </PageSection>
            <PageSection centered="true">
                <p>For access please contact your service owner.</p>
            </PageSection>
        </PageLayout>
    );
}